'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var clone = require('./clone.js');
var mergeWith = require('./mergeWith.js');
var isPlainObject = require('../predicate/isPlainObject.js');
function toMerged(target, source) {
    return mergeWith.mergeWith(clone.clone(target), source, function mergeRecursively(targetValue, sourceValue) {
        if (Array.isArray(sourceValue)) {
            if (Array.isArray(targetValue)) {
                return mergeWith.mergeWith(clone.clone(targetValue), sourceValue, mergeRecursively);
            } else {
                return mergeWith.mergeWith([], sourceValue, mergeRecursively);
            }
        } else if (isPlainObject.isPlainObject(sourceValue)) {
            if (isPlainObject.isPlainObject(targetValue)) {
                return mergeWith.mergeWith(clone.clone(targetValue), sourceValue, mergeRecursively);
            } else {
                return mergeWith.mergeWith({}, sourceValue, mergeRecursively);
            }
        }
    });
}
exports.toMerged = toMerged;
